export { default as EN_TIMEZONES } from "../timezones/en-timezones.json";
export { default as EN } from "./en.json";
export const SHARED_NAMESPACE = "shared";
